import { readState } from "@/__main__/app-state.mjs";
import { getRitoLanguageCodeFromBCP47 } from "@/app/util.mjs";
import {
  CHAMPIONS,
  CHAMPIONS_KEY_TO_ID,
} from "@/game-lol/constants/champion-classes.mjs";
import { getCurrentPatchForStaticData } from "@/game-lol/utils/patches.mjs";
import { getLocale } from "@/util/i18n-helper.mjs";

const staticDataKeys = new Set([
  "champions",
  "items",
  "spells",
  "runes",
  "runeDetails",
  "augments",
  "anvils",
]);
export function getStaticData(key, patch, isdict) {
  if (!patch) patch = getCurrentPatchForStaticData();
  const lang = getLocale();
  const ritoLanguageCode = getRitoLanguageCodeFromBCP47(lang);
  const result = readState.lol.staticData[ritoLanguageCode]?.[patch]?.[key];
  const langs = Object.keys(readState.lol.staticData);
  const fallBackResult =
    readState.lol.staticData[langs[langs.length - 1]]?.[patch]?.[key];
  if (!staticDataKeys.has(key) && !result && !fallBackResult)
    throw new Error(`Invalid static data key "${key}"`);
  return result || fallBackResult || (isdict && {}) || [];
}

// getStaticChampionByKey
// @param championKey : championKey is not same with champion name.
//                      championKey has not space but champion name has.
export const getStaticChampionByKey = (championKey = "", patch) => {
  const champions = getStaticData("champions", patch, true);

  const championsLower = Object.entries(champions || {}).reduce((acc, curr) => {
    const [key, val] = curr;
    acc[key.toLowerCase()] = val;
    return acc;
  }, {});

  const champion = championsLower[championKey?.toLowerCase()];

  return champion
    ? {
        ...champion,
        id: champion.key,
        key: championKey,
      }
    : null;
};

export function getPrereleaseChampionByKey(championKey) {
  const championId = CHAMPIONS_KEY_TO_ID[championKey];
  if (!championId) throw new Error(`Invalid champion key "${championKey}"`);
  const info = CHAMPIONS[championId] || {};
  return {
    ...info,
    id: championId,
  };
}
